import styled from '@emotion/styled';
import React from 'react';
import Chip from '@mui/material/Chip';
import moment from 'moment';


const getAgeOld = (dob) => {
    let dif = moment().diff(dob, 'years');
    if (dif < 1) {
        dif = moment().diff(dob, "months");
        if (dif < 1) {
            dif = moment().diff(dob, "days");
            return `${dif} days old`;
        }
        return `${dif} months old`;
    }
    return `${dif} years old`;
}

const Childrens = ({ childrens }) => {
    return (
        <>

            <Container>
                <strong className="title">
                    Children
                </strong>
                {
                    childrens.length > 0 && childrens[0].length > 0 ?
                        childrens[0].map((e) => {
                            return (
                                <div key={e._id}>
                                    <Chip label={e.name} size="small" className="mui-clip" />
                                    <small>{getAgeOld(e.dateOfBirth)}</small>
                                </div>
                            )
                        })
                        :
                        <><div>No childrens add yet.</div></>}
            </Container>
        </>
    )
}

const Container = styled("div")`
    height: 100%;
    width: 100%;
    display: grid;
    row-gap: 0.5rem;
    .title{
        color: var(--nona-theme-color);
        font-size: 90%;
    }
    &>div{
        width: 80%;
        display: flex;
        justify-content: space-between;
    }
`;

export default Childrens